import { Toaster } from '@upme/ui/components/sonner';
import type { PropsWithChildren } from 'react';
import { ThemeProvider } from '../shared/theme/theme-provider';

export function Providers({ children }: PropsWithChildren) {
  return (
    <ThemeProvider>
      {children}
      <Toaster richColors closeButton />
    </ThemeProvider>
  );
}
